<template>
  <PlatDataPanelUniformExam :custom-id="customId">
    <template #default="{batchId}">
      <template v-if="batchId">
        <keep-alive>
          <ExamUniformStudentScoreWrap :key="batchId"
                                       :batch-id="batchId"></ExamUniformStudentScoreWrap>
        </keep-alive>
      </template>
    </template>
  </PlatDataPanelUniformExam>
</template>

<script>
import PlatDataPanelUniformExam from '../../../../wrapper/panel/PlatDataPanelUniformExam'
import ExamUniformStudentScoreWrap from './wrap'
import routeConfig from '../../../../../../../../constants/routeConfig'
export default {
  name: 'ExamUniformStudentScore',
  components: {
    PlatDataPanelUniformExam,
    ExamUniformStudentScoreWrap
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>
